import { render, staticRenderFns } from "./link.vue?vue&type=template&id=0116fc75&"
import script from "./link.vue?vue&type=script&lang=ts&"
export * from "./link.vue?vue&type=script&lang=ts&"
import style0 from "./link.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports